import { formatDateLocal } from '../../../../../lib/script'
import classes from './RequestListItem.module.css'


export default function RequestListItem({data, showRequestsExpanded, activeRequest}) {

    function openRequestHandler() {
        if (showRequestsExpanded) {
            showRequestsExpanded(data)
        }
    }

    return <button className={`${classes.container} ${activeRequest == data.id ? classes.active : ''}`} onClick={openRequestHandler}>
        <div className={classes.item_info}>
            <div className={classes.item_info_left}>
                {data.is_resolved ? <div className={classes.resolved_badge}></div> : <div className={classes.pending_badge}></div>}
                <div className={classes.item_info_item}>{data.type == 'user' ? 
                // Outbound
                    <span><i className='ti ti-arrow-up-right'></i> </span> 
                    : 
                    // Inbound
                    <span><i className='ti ti-arrow-down-left'></i> </span>
                    }</div>
                <div className={classes.item_info_item_right}>
                    {(!data.is_resolved && data.unread_messages_count && data.unread_messages_count > 0) ? <div className={classes.unread_messages_count}>{data.unread_messages_count} <i className='ti ti-message'></i></div> : null}
                </div>
            </div>
            <div className={classes.item_info_date}>
                {formatDateLocal(data.created_at)}
            </div>
        </div>
        <div className={classes.container_inner}>
            
            <div className={classes.title}>
                
                {/* {data.title} */}
                {data.title?.substring(0, 95)}{data.title?.length > 95 ? '...' : ''}
            </div>
            <div className={classes.description}>{data.description?.substring(0, 50)}{data.description?.length > 50 ? '...' : ''}</div>
        </div>
        
    </button>
}